<template>
  <div class="ukey">
    <div class="tabbar"><span class="iconfont" @click="handleGo()">{{'\ue682'}}</span></div>
    <div class="ukey-box">
    <header>绑定终端</header>
    <p v-if="flag === 0"><span class="iconfont">{{'\ue6e2'}}</span>当前账号暂无权限，请切换账号后重试</p>
    <div class="ukey-box-model">
      <img src="../../../../src/assets/img/ukeyBox.png" class="ukey-img"/>
    </div>
    <div class="ukey-box-message">
      <div class="ukey-name">
        <span>型号</span><span>{{ message.name }}</span>
      </div>
      <div class="ukey-code">
        <span>设备SN</span><span>{{ ukeyBox.boxCode }}</span>
      </div>
    </div>
    <div :class="['set-phone',colorShow ? 'color' : '']">
      <FormList
        :list="formList"
        :data="formData"
        :onChange="onInputChange"
      />
    </div>
    <div v-if="flag !== 0" :class="['next-step', showButton ? '' : 'disabled-button']" @click="showButton ? handleClick() : '' ">
      {{getTitle}}
    </div>
  </div>
  </div>
</template>
<script>
import { ukeyBoxRequest } from '@services'
import FormList from '@components/FormList'
import { Field, Notify, Dialog } from 'vant'
export default {
  data () {
    return {
      ukeyBox: {

      },
      message: {
        code: '0123213213213213',
        name: 'Ukey盒子'
      },
      flag: '',
      formData: {
        deviceNo: '',
        deviceType: '',
        deviceTypeNum: ''
      },
      formList: [
        // {
        //   type: 'text',
        //   field: 'ukeyCode',
        //   label: '税务Ukey编码',
        //   placeholder: '请输入税务Ukey编码',
        //   maxlength: 50,
        //   readonly: true
        // },
        {
          type: 'text',
          field: 'deviceNo',
          placeholder: '请输入盘号',
          label: '盘号',
          readonly: true
        },
        {
          type: 'text',
          field: 'deviceType',
          placeholder: '请输入盘类型',
          label: '盘类型',
          readonly: true
        }
      ]
    }
  },
  async mounted () {
    let ukeyBox
    if (sessionStorage.ukeyBox) {
      ukeyBox = JSON.parse(sessionStorage.ukeyBox)
      this.ukeyBox = ukeyBox
    } else {
      return
    }
    let data = await ukeyBoxRequest.ukeyBox.getBoxInfo({ boxCode: ukeyBox.boxCode })
    if (data.success) {
      this.formData.deviceNo = data.result.deviceNo
      this.formData.deviceTypeNum = data.result.deviceType
      let deviceType
      switch (data.result.deviceType) {
        case 0:
          deviceType = '金税盘'
          break
        case 1:
          deviceType = '税控盘'
          break
        case 2:
          deviceType = 'UKEY'
          break
        case 3:
          deviceType = '税控服务器'
          break
        default:
          break
      }
      this.formData.deviceType = deviceType
    } else {
      Notify({ type: 'danger', message: data.message })
    }
    let result = await ukeyBoxRequest.ukeyBox.getValidPerm({ ...ukeyBox, deviceNo: this.formData.deviceNo })
    if (result.success) {
      this.flag = result.result
    } else {
      Notify({ type: 'danger', message: result.message })
    }
  },
  methods: {
    async handleClick () {
      if (this.flag === 1) {
        // 确认绑定
        return this.$router.push('/ukey/holding-password')
      } else if (this.flag === 2) {
        // 解除绑定
        Dialog.confirm({
          message: '解除绑定后仍可重新扫码再次建立绑定关系，是否解除?',
          confirmButtonColor: '#3378FF'
        })
          .then(async () => {
            let data = await ukeyBoxRequest.ukeyBox.setBindRemove({ boxCode: this.ukeyBox.boxCode })
            if (data.success) {
              Notify({ type: 'success', message: '解除绑定成功!' })
              return setTimeout(() => {
                this.$router.push('/')
              }, 2000)
            } else {
              Notify({ type: 'danger', message: data.message })
            }
          })
          .catch(() => {
          })
      } else if (this.flag === 3) {
        // 更换绑定
        Dialog.confirm({
          message: '更换绑定后当前税盘将与此税控盒子建立绑定关系,是否更换?',
          confirmButtonColor: '#3378FF'
        })
          .then(() => {
            return this.$router.push({ path: '/ukey/holding-password', query: { action: 2 } })
          })
          .catch(() => {
          })
      } else {
        console.log('啥也没有')
      }
    },
    handleGo () {
      this.$router.go(-1)
    },
    onInputChange ({ e, field }) {
      this.formData[field] = e
    }
  },
  computed: {
    showButton () {
      if (this.formData.deviceNo === '' || this.formData.deviceType === '') {
        return false
      } else {
        return true
      }
    },
    colorShow () {
      if (this.formData.deviceNo !== '' || this.formData.deviceType !== '') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.flag === 1) {
        return '确认绑定'
      } else if (this.flag === 2) {
        return '解除绑定'
      } else if (this.flag === 3) {
        return '更换绑定'
      } else {
        return ''
      }
    }
  },
  components: {
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Dialog.name]: Dialog,
    FormList
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
